import { render } from "./UserApi.vue?vue&type=template&id=6a383a52"
import script from "./UserApi.vue?vue&type=script&lang=js"
export * from "./UserApi.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__